<div [class]="className">
  <p-dialog
    [(visible)]="open"
    [resizable]="false"
    [modal]="true"
    [draggable]="false"
    [breakpoints]="breakpoints"
    [dismissableMask]="dismissableMask"
    (onHide)="onDialogHide()"
    [style]="style"
    closeAriaLabel="close modal"
    [class]="showCloseIcon ? '' : 'no-close-icon'"
  >
    <ng-template pTemplate="header">
      <div class="w-full text-center">
        @if (!alignStart) {
          <app-typography
            variant="header"
            [color]="variant === 'primary' ? 'white' : 'textPrimary'"
            >{{ title }}</app-typography
          >
        } @else {
          <app-typography
            class="flex justify-start"
            variant="header"
            [color]="variant === 'primary' ? 'white' : 'textPrimary'"
            >{{ title }}</app-typography
          >
        }
      </div>
    </ng-template>
    <ng-template pTemplate="closeicon" *ngIf="showCloseIcon">
      <div
        class="h-6 w-6 {{
          variant === 'primary' ? 'text-white' : 'text-black'
        }} hover:text-primary"
        (click)="handleClose($event)"
      >
        <i class="pi pi-times"></i>
      </div>
    </ng-template>
    <ng-template pTemplate="closeicon" *ngIf="!showCloseIcon">
      <!-- Empty template to override PrimeNG's default close icon -->
    </ng-template>

    <div class="py-4">
      <ng-content></ng-content>
    </div>
    <ng-template pTemplate="footer" class="border-none p-0" *ngIf="showFooter">
      @if (buttonAlignment.length > 0 && haveCancellation) {
        <div
          class="flex flex-wrap-reverse {{
            buttonAlignment
          }} px-16 sm:flex-col sm:gap-3 md:flex-row"
        >
          <div class="border-none sm:order-2 md:order-1">
            <app-button
              variant="text"
              label="{{ cancelButtonLabel }}"
              (sendClick)="onCancelClick($event)"
            />
          </div>
          <div class="sm:order-1 md:order-2">
            <app-button
              size="large"
              label="{{ confirmButtonLabel }}"
              [type]="'submit'"
              [loading]="saving"
              (sendClick)="onConfirmationClick($event)"
            />
          </div>
        </div>
      } @else {
        <div
          *ngIf="haveCancellation; else noCancellation"
          class="flex flex-wrap-reverse items-center justify-center px-16 sm:flex-col sm:gap-3 md:flex-row md:justify-between"
        >
          <div class="border-none sm:order-2 md:order-1">
            @if (cancelButtonLabel) {
              <app-button
                variant="text"
                label="{{ cancelButtonLabel }}"
                (sendClick)="onCancelClick($event)"
              />
            }
          </div>

          <div class="sm:order-1 md:order-2">
            <app-button
              size="large"
              label="{{ confirmButtonLabel }}"
              [loading]="saving"
              (sendClick)="onConfirmationClick($event)"
            />
          </div>
        </div>
      }
      <ng-template #noCancellation>
        <app-button
          size="large"
          [fullWidth]="true"
          label="{{ confirmButtonLabel }}"
          [loading]="saving"
          (sendClick)="onConfirmationClick($event)"
        />
      </ng-template>
    </ng-template>
  </p-dialog>
</div>
